import type { Programa, TipoUnidade } from 'types/pessoa';
import type { CategoriaPreInscricao } from 'utils/pessoa';

/**
 * Configuração da pré-inscrição por categoria. O formulário único lê tudo daqui;
 * não há `if` de categoria no JSX.
 */
export interface ConfigPreInscricao {
  categoria: CategoriaPreInscricao;
  nome: string;
  /** Texto do botão para quem participa dos dois programas e escolhe a categoria. */
  rotuloEscolha: string;
  /** Título do formulário: "Faça a pré-inscrição da {tituloIniciativa} no". */
  tituloIniciativa: string;
  /** Subtítulo do formulário (produto e categoria). */
  subtitulo: string;
  /** Quantidade de participantes, incluindo o cadastrante. */
  participantes: { min: number; max: number };
  /** Programa que o participante precisa ter; `null` dispensa o filtro. */
  programaParticipante: Programa | null;
  temCategoriaEcbb: boolean;
  /** Negócios e Atendimento escolhe a categoria nas informações da iniciativa. */
  temCategoriaConexao: boolean;
  /** Tipo de unidade do "Alterar"; `null` mostra todas. */
  tipoUnidade: TipoUnidade | null;
}

/** Rótulo do campo de unidade, igual em todas as categorias. */
export const ROTULO_UNIDADE_VALIDADORA = 'Unidade responsável pela aprovação';

export const DESCRICAO_UNIDADE_VALIDADORA =
  'Essa unidade é responsável pela aprovação da iniciativa cadastrada. Caso não seja esta unidade você pode alterar.';

export const CONFIG_PRE_INSCRICAO: Record<CategoriaPreInscricao, ConfigPreInscricao> = {
  CONEXAO: {
    categoria: 'CONEXAO',
    nome: 'Negócios e Atendimento',
    rotuloEscolha: '"Negócios e Resultados" ou "Atendimento e Experiência do Cliente"',
    tituloIniciativa: 'iniciativa negocial',
    subtitulo: 'Prêmio BB',
    participantes: { min: 3, max: 5 },
    programaParticipante: 'PREMIO_CONEXAO',
    temCategoriaEcbb: false,
    temCategoriaConexao: true,
    tipoUnidade: 'SUPER',
  },
  PILAR: {
    categoria: 'PILAR',
    nome: 'Pilar de Sustentação',
    rotuloEscolha: 'Pilar de Sustentação',
    tituloIniciativa: 'iniciativa estruturante',
    subtitulo: 'Prêmio BB - Pilar de Sustentação',
    participantes: { min: 3, max: 5 },
    programaParticipante: 'JOGA_JUNTO_PREDEFINIDO',
    temCategoriaEcbb: false,
    temCategoriaConexao: false,
    tipoUnidade: 'DIRETORIA',
  },
  ELBB: {
    categoria: 'ELBB',
    nome: 'ELBB',
    rotuloEscolha: 'ELBB',
    tituloIniciativa: 'iniciativa',
    subtitulo: 'Prêmio ELBB',
    participantes: { min: 2, max: 5 },
    // Regra atual do ELBB: qualquer funcionário elegível (design DD1).
    programaParticipante: null,
    temCategoriaEcbb: true,
    temCategoriaConexao: false,
    tipoUnidade: null,
  },
};
